
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { name: 'Home', id: 'home' },
    { name: 'About', id: 'about' },
    { name: 'Portfolio', id: 'portfolio' },
    { name: 'Skills', id: 'skills' },
    { name: 'Contact', id: 'contact' }
  ];

  const services = [
    'Brand Identity Design',
    'Logo Design',
    'UI/UX Design',
    'Print Design',
    'Packaging Design',
    'Visual Storytelling'
  ];

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white mb-4">
              <span className="text-yellow-400">Anietie</span> Udoh
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Professional graphics designer crafting visual identities that speak without words. Specializing in branding, product design, and visual storytelling.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/anietudoh"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-yellow-400 text-gray-400 hover:text-black rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://linkedin.com/in/anietudoh"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-yellow-400 text-gray-400 hover:text-black rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a
                href="https://dribbble.com/anietudoh"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-yellow-400 text-gray-400 hover:text-black rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-dribbble-line text-lg"></i>
              </a>
              <a
                href="https://behance.net/anietudoh"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-yellow-400 text-gray-400 hover:text-black rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-behance-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-lg">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-yellow-400 transition-colors text-sm cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-lg">Services</h4>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index} className="text-gray-400 text-sm">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-lg">Get In Touch</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-yellow-400"></i>
                <span className="text-gray-400 text-sm">anietieu6@gmail.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-yellow-400"></i>
                <span className="text-gray-400 text-sm">+234 903 670 1928</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-yellow-400"></i>
                <span className="text-gray-400 text-sm">Online</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2024 Aniet Udoh. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
              <span className="text-gray-600">|</span>
              <span className="text-gray-400 text-sm">
                Designed with passion & precision
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
